import { Theme } from 'config';

const inputStyles = {
  margin: '.75rem 0 0 0',
  maxWidth: '100%',
  flex: '1 0 auto',
  outline: 0,
  textAlign: 'left',
  lineHeight: '1.21428571em',
  padding: '.67857143em 1em',
  backgroundColor: '#FFF',
  border: '.05rem solid rgba(34,36,38,.15)',
  color: 'rgba(0,0,0,.87)',
  borderRadius: '.28571429rem',
  transition:
    'box-shadow .1s ease,border-color .1s ease,-webkit-box-shadow .1s ease',
  boxShadow: 'none',
};

const styles = (theme: Theme) => ({
  header: {
    backgroundColor: `${theme.violet} !important`,
    color: '#FFF !important',
    fontSize: '1.15rem !important',
  },
  fieldGroup: {
    padding: '.5rem',
    overflow: 'visible',
    textOverflow: 'ellipsis',
  },
  label: {
    display: 'block',
  },
  message: {
    color: theme.coral,
    marginLeft: '.5rem',
    fontSize: '.85rem',
  },
  disabled: {
    backgroundColor: `${theme.softGray} !important`,
    color: `${theme.darkGray} !important`,
    cursor: 'auto !important',
  },
  input: inputStyles,

  '@global .DayPickerInput > input': inputStyles,
  '@global .ui.page.dimmer': {
    backgroundColor: 'rgba(0, 0, 0, .8)',
  },
});

export default styles;
